import { useState, type FormEvent } from "react";

const FORM_ENDPOINT = "https://readdy.ai/api/form/dahc0e3p14a1h3mr6i6g";

export default function NewsletterForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，感谢你的加入！");
      form.reset();
      return;
    }
    formData.delete("website_alt");

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      params.append(key, String(value));
    });

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功，感谢你的加入！");
        form.reset();
      } else {
        setStatus("error");
        setMessage(
          typeof serverMsg === "string" && serverMsg && !isSpam
            ? serverMsg
            : "提交失败，请稍后重试。",
        );
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请检查网络后重试。");
    }
  }

  return (
    <div>
      <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-3 sm:flex-row" noValidate>
        <input
          type="text"
          name="website_alt"
          className="newsletter-hp-field"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <label htmlFor="newsletter-email" className="sr-only">
          邮箱地址
        </label>
        <input
          id="newsletter-email"
          type="email"
          name="email"
          required
          placeholder="输入你的邮箱"
          className="h-11 w-full rounded-md border border-background-300 bg-background-50 px-4 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="h-11 shrink-0 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
        >
          {status === "loading" ? "提交中…" : "订阅更新"}
        </button>
      </form>
      {message && (
        <p
          role="status"
          className={`mt-3 text-xs ${status === "success" ? "text-secondary-600" : "text-primary-600"}`}
        >
          {message}
        </p>
      )}
      <p className="mt-2 text-xs text-foreground-500">每周一封，只推乐子，不发广告，随时可退订。</p>
    </div>
  );
}